import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  label: {
    marginTop:'10px',
    fontSize: 14,
    color: '#2B3990',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  icon: { width: '47px', height: '47px' },
  labelGray: {
    marginTop: theme.spacing(3),
    fontSize: 12,
    color: '#B2B6B6',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  img: {
    width: '100%',
    maxWidth: '40px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));